/**
 * @file 本を読む画面のヘッダーの印である。
 *
 * @what: 群ごとに違う印を持つ。AI に渡すものは ✦、教材から選ぶものは紙面の枠、そのほかは
 *   本と時計の印を使う。
 * @why: 性格の違うボタンが同じ見た目で並ぶと、どれが AI を呼ぶのか分からない (代表の指摘、
 *   2026-09-10)。印と色で群を見分けられるようにする。
 * @failure: 描画のみ。印だけで意味を持たせず、必ず文字と併せて使う。
 */

const base = {
  className: "study-viewer-btn-icon",
  viewBox: "0 0 14 14",
  "aria-hidden": true,
  focusable: "false" as const,
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.4,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

/** AI に渡すもの・AI が返したものに付ける印である。 */
export function SparkIcon() {
  return (
    <svg {...base}>
      <path d="M7 1.5 8.3 5.7 12.5 7 8.3 8.3 7 12.5 5.7 8.3 1.5 7 5.7 5.7Z" />
    </svg>
  );
}

/** 紙面の1ページを選ぶ印である。 */
export function SelectPageIcon() {
  return (
    <svg {...base}>
      <rect x="2.5" y="1.8" width="9" height="10.4" rx="1.2" />
      <path d="M5 5.2h4M5 7.4h4M5 9.6h2.5" />
    </svg>
  );
}

/** 紙面の一部を囲む印である。 */
export function SelectRectIcon() {
  return (
    <svg {...base} strokeDasharray="2 1.6">
      <rect x="2" y="3" width="10" height="8" rx="1" />
    </svg>
  );
}

/** 本に載っている答えの印である。 */
export function BookIcon() {
  return (
    <svg {...base}>
      <path d="M2 3.2c1.7-.7 3.3-.7 5 0v8c-1.7-.7-3.3-.7-5 0Z" />
      <path d="M12 3.2c-1.7-.7-3.3-.7-5 0v8c1.7-.7 3.3-.7 5 0Z" />
    </svg>
  );
}

/** 学習の記録の印である。 */
export function ClockIcon() {
  return (
    <svg {...base}>
      <circle cx="7" cy="7" r="5.2" />
      <path d="M7 4.2V7l2 1.4" />
    </svg>
  );
}

/** 付属音声を鳴らす印である。 */
export function SoundIcon() {
  return (
    <svg {...base}>
      <path d="M3 5.4h2.2L8 3.2v7.6L5.2 8.6H3Z" />
      <path d="M10 5.2a2.6 2.6 0 0 1 0 3.6" />
    </svg>
  );
}

/** 鳴っている音を止める印である。 */
export function SoundStopIcon() {
  return (
    <svg {...base}>
      <rect x="3.2" y="3.4" width="2.6" height="7.2" rx="0.6" />
      <rect x="8.2" y="3.4" width="2.6" height="7.2" rx="0.6" />
    </svg>
  );
}

/**
 * 隠した操作の段を引っ張り出す印である。つまみの下に下向きの山を置く。
 *
 * ほかの印と違って文字を併せないので、大きめの枠 (20×14) で出す。
 */
export function PullDownIcon() {
  return (
    <svg {...base} viewBox="0 0 20 14" className="study-viewer-pull-icon" strokeWidth={1.8}>
      <path d="M5 3.5h10" />
      <path d="M6.5 7.5 10 11l3.5-3.5" />
    </svg>
  );
}
